<template>
  <div>
    <div class="content-wrap">
      <div class="main">
        <div class="container-fluid">
          <section id="main-content">
            <div id="mainSection">
              <nav class="d-flex" style="justify-content: space-between">
                <ol class="breadcrumb" style="font-size:1rem">
                  <li class="breadcrumb-item">
                    <a href="#" data-path="all" @click.prevent="clearPicked">人員總覽</a>
                  </li>
                  <li class="breadcrumb-item" v-if="picked.flag">
                    <span>{{picked.obj.name}}</span>
                  </li>
                </ol>
              </nav>
              <div class="row namelistGroup" v-if="mainData.length > 0 && !picked.flag">
                <div class="col-lg-4 personInfo" v-for="person in mainData" :key="person.index">
                  <div class="card" :data-id="person.id">
                    <div class="card-title pr d-flex">
                      <div class="avatar" style="width:75px">
                        <img
                          :src="'https://picsum.photos/400/400?random='+person.index"
                          class="img-fluid img-thumbnail"
                        />
                      </div>
                      <div class="info">
                        <span>{{person.name}}</span>
                        <span>{{person.department}}</span>
                      </div>
                    </div>
                    <div class="card-body d-flex">
                      <div
                        class="evaluate"
                        :data-id="person.account"
                        :data-name="person.name"
                        :data-grade="person.grade"
                      >
                        <i
                          class="ti-star setPoint"
                          :class="{'gradeActive':person.grade >= 1}"
                          data-point="1"
                        ></i>
                        <i
                          class="ti-star setPoint"
                          :class="{'gradeActive':person.grade >= 2}"
                          data-point="2"
                        ></i>
                        <i
                          class="ti-star setPoint"
                          :class="{'gradeActive':person.grade >= 3}"
                          data-point="3"
                        ></i>
                        <i
                          class="ti-star setPoint"
                          :class="{'gradeActive':person.grade >= 4}"
                          data-point="4"
                        ></i>
                        <i
                          class="ti-star setPoint"
                          :class="{'gradeActive':person.grade == 5}"
                          data-point="5"
                        ></i>
                      </div>
                      <div>
                        <a
                          href="#"
                          class="btn btn-warning btn-addon browse"
                          @click.prevent="setPicked(person)"
                        >
                          <i class="ti-user"></i>
                          瀏覽
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 memberdash section1" v-if="picked.flag">
                <div class="row">
                  <div class="col-lg-4 section1group browseInfo">
                    <div class="card">
                      <div class="card-title d-flex mb-2">
                        <div class="avatar" style="position: relative">
                          <img
                            :src="'https://picsum.photos/400/400?random='+picked.obj.index"
                            class="img-fluid img-thumbnail"
                          />
                          <label class="icon-upload" for="upload-avatar" v-if="!picked.imgUpload">
                            <span class="fa-stack fa-lg">
                              <i class="fa fa-circle fa-stack-2x"></i>
                              <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
                            </span>
                          </label>
                          <input
                            type="file"
                            id="upload-avatar"
                            class="custom-input"
                            accept=".png, .jpg, .peg"
                          />
                        </div>
                        <!-- <div class="info d-flex">
                          <p>
                            姓名：
                            <span data-info="name">{{picked.obj.name}}</span>
                          </p>
                          <span v-if="User.auth === '1'">
                            <a
                              href="#"
                              class="btn btn-dark btn-sm follow"
                              v-if="!trackList.includes(picked.obj.id)"
                              @click.prevent="setTrackMemberHandler(true)"
                            >追蹤</a>
                            <a
                              href="#"
                              class="btn btn-danger btn-sm follow"
                              v-else
                              @click.prevent="setTrackMemberHandler(false)"
                            >追蹤中</a>
                            <a
                              href="#"
                              class="btn btn-dark btn-sm editSkill"
                              @click.prevent="showEdit($event)"
                            >編輯</a>
                          </span>
                        </div>-->
                      </div>
                      <div class="card-body d-flex">
                        <p>
                          部門：
                          <span data-info="dep">{{picked.obj.department}}</span>
                        </p>
                        <p>
                          名稱：
                          <span data-info="examid">{{picked.obj.name}}</span>
                        </p>
                      </div>
                      <div class="card-footer d-flex">
                        <button class="btn btn-dark viewAll">總覽</button>
                        <button
                          class="btn btn-dark sendMsg"
                          data-toggle="modal"
                          data-target="#myModal_msg"
                        >發佈公告</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 section1group work">
                    <div class="card">
                      <div class="card-body">
                        <div data-work="duty" class="wk-title mb-3">
                          <p>主要工作內容</p>
                          <span>{{picked.obj.duty}}</span>
                        </div>
                        <div data-work="skill" class="wk-title">
                          <p>工作技能</p>
                          <span>{{picked.obj.skill}}</span>
                        </div>
                        <div data-work="worktime" class="wk-title">
                          <p>工作時間</p>
                          <span>{{picked.obj.workTime}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 section1group msg">
                    <div class="card">
                      <div class="card-title pr">公告</div>
                      <div class="card-body table-responsive">
                        <table class="table table-hover table-borderless msgTable">
                          <thead>
                            <tr>
                              <td>內容</td>
                              <td>公告者</td>
                              <td>時間</td>
                              <td>附件</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>目標100%</td>
                              <td>admin</td>
                              <td>11-30</td>
                              <td>
                                <span>附件</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="card-footer"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 memberdash section2" v-if="picked.flag">
                <div class="card">
                  <div class="card-title">
                    <h4>Time Line</h4>
                  </div>
                  <div class="card-body mb-2">
                    <ul class="timeline" v-if="filterTimeLineData.length > 0">
                      <li
                        class="timelineData"
                        :data-time="item"
                        v-for="(item,index) in filterTimeLineData"
                        :key="index"
                      >
                        <div class="timeline-badge" :class="item.color"></div>
                        <span class="timeline-time">{{item.time}}</span>
                        <div class="timeline-panel">
                          <div class="timeline-heading">
                            <h5 class="timeline-title">
                              {{ time.content}}
                              <a
                                href="javascript:;"
                                class="deleteLog"
                                title="刪除"
                                style="float:right"
                                v-if="item.flag"
                                @click.prevent="deleteTimeLineData(item.origin)"
                              >&times;</a>
                            </h5>
                          </div>
                          <div class="timeline-body">
                            <p>{{item.content}}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="card-footer">
                    <form @submit.prevent>
                      <input
                        type="datetime-local"
                        class="form-control inputTime"
                        v-model="picked.timeLine.inputTime"
                      />
                      <input
                        type="text"
                        class="form-control mt-2 inputContent"
                        placeholder="內容"
                        v-model.trim="picked.timeLine.content"
                      />
                      <button
                        class="btn btn-secondary mt-2"
                        style="float:right"
                        @click="addNewWork"
                      >送出</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="trackingGroup"></div>
          </section>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModal_edit" tabindex="1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">編輯</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="mainDuty">主要工作內容</label>
              <select
                class="form-control"
                multiple="multiple"
                id="mainDuty"
                v-model="picked.edit.duty"
              >
                <option v-for="(duty, index) in allDuty" :key="index" :value="duty">{{duty}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="mainSkill">工作技能</label>
              <select multiple class="form-control" id="mainSkill" v-model="picked.edit.skill">
                <option v-for="(skill, index) in allDuty" :key="index" :value="skill">{{skill}}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="form-row">
                <div class="col-md-6 mb-3">
                  <label for="onWorkInput">上班時間</label>
                  <input
                    type="time"
                    id="onWorkInput"
                    name="onwork"
                    class="form-control"
                    v-model="picked.edit.ontime"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label for="offWorkInput">下班時間</label>
                  <input
                    type="time"
                    id="offWorkInput"
                    name="offwork"
                    class="form-control"
                    v-model="picked.edit.offtime"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="setEditData">確定儲存</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModal_msg" tabindex="1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">發佈公告</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="msgTitle" class="col-form-label">訊息標題</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  id="msgTitle"
                  placeholder="輸入標題"
                  v-model.trim="picked.alert.msgTitle"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="msgTxt" class="col-form-label">訊息內容</label>
              <div>
                <input
                  type="textarea"
                  class="form-control"
                  id="msgTxt"
                  placeholder="輸入內容"
                  v-model.trim="picked.alert.msgTxt"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="msgTxt" class="col-form-label">夾帶圖片(jpg)</label>
              <div>
                <input
                  type="file"
                  id="msgFile"
                  accept=".png, .jpg, .peg"
                  multiple
                  @change="uploadMsgFile($event)"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="saveMsg">確定發佈</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/js/lib/select2/select2.full.min.js";
export default {
  data() {
    return {
      mainDep: "",
      mainDepName: "",
      nameList: {
        list: [],
        examiner: []
      },
      picked: {
        flag: false,
        obj: "",
        msg: [],
        edit: {
          duty: [],
          skill: [],
          ontime: "",
          offtime: ""
        },
        imgUpload: false,
        alert: {
          fileflag: false,
          fileContent: {},
          msgTitle: "",
          msgTxt: ""
        },
        timeLine: {
          getTimeLineReq: "",
          timeLineData: [],
          inputTime: "",
          content: ""
        }
      },
      allDuty: [],
      msgTypeList: []
    };
  },
  // props: {
  //   mainColorObj: {
  //     type: Object,
  //     required: true
  //   },
  //   time: {
  //     type: Object,
  //     required: true
  //   },
  //   User: {
  //     type: Object,
  //     required: true
  //   },
  //   trackList: {
  //     type: Array,
  //     required: true
  //   }
  // },
  created() {
    this.mainDep = this.$route.params.dep;
    // this.mainData = this.$store.state.members;
    // if (this.mainDep === 'poster') this.mainDepName = '海報';
    // if (this.mainDep === 'card') this.mainDepName = '名片';
    // if (this.mainDep === 'ink') this.mainDepName = '大圖';
    // if (this.mainDep === 'digit') this.mainDepName = '數位';

    // $.ajax({
    //   url: './php/main.php',
    //   // url: '/api/main.php',
    //   type: 'post',
    //   data: { function: 'getDepNameList', dep: this.mainDep }
    // }).done(res => {
    //   this.nameList.list = JSON.parse(res);
    //   (async () => {
    //     await this.getExaminerList();
    //     await this.getDutyAndSkillHandler();
    //   })();
    // });
  },
  computed: {
    mainData() {
      return this.$store.state.members ? this.$store.state.members : false;
    },
    mainNameList() {
      if (this.nameList.examiner.length == 0) return [];
      let { list, examiner } = this.nameList;
      return examiner.reduce((prev, next) => {
        let obj = {
          name: next.name,
          id: next.gh_id,
          examId: "",
          grade: next.point,
          duty: next.mainDuty || "未設定",
          skill: next.workskill || "未設定",
          workTime: `${next.onwork}~${next.offwork}`,
          imgurl: next.imgurl || "img/user.png"
        };
        let ary = list.filter(el => next.gh_id === el.id);
        obj.examId =
          ary.length > 0 && ary[0]["id"] === next.gh_id
            ? ary[0]["examId"]
            : next.gh_id;
        prev.push(obj);
        return prev;
      }, []);
    },
    filterTimeLineData() {
      if (this.picked.timeLine.timeLineData.length == 0) return [];
      let ary = sortTimeLine(this.picked.timeLine.timeLineData);
      return ary.reduce((prev, next) => {
        let [time, content] = next.split(">>");
        let origin = next;
        let color = "warning";
        let flag = false;
        if (content === "開始web審稿52" || content === "web審稿完畢62") {
          color = "primary";
        }
        if (content === "線下開始審稿" || content === "線下審稿完畢") {
          color = "info";
        }
        if (color === "warning") {
          flag = true;
        }
        time = time.split(".")[0];
        let a = Object.assign(
          {},
          {
            time,
            content,
            flag,
            color,
            origin
          }
        );
        prev.push(a);
        return prev;
      }, []);
    }
  },
  methods: {
    getExaminerList() {
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: { function: "getExaminerData", depType: this.mainDep }
      }).done(res => {
        this.nameList.examiner = JSON.parse(res);
      });
    },
    clearPicked() {
      this.picked = {
        flag: false,
        obj: "",
        msg: [],
        edit: {
          duty: [],
          skill: [],
          ontime: "",
          offtime: ""
        },
        imgUpload: false,
        alert: {
          fileflag: false,
          fileContent: {},
          msgTitle: "",
          msgTxt: ""
        },
        timeLine: {
          getTimeLineReq: "",
          timeLineData: [],
          inputTime: "",
          content: ""
        }
      };
    },
    setPoint(id, name, point) {
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: {
          function: "setMemberPoint",
          point: point,
          repsid: id,
          repsname: name,
          deptype: this.mainDep
        }
      }).done(res => {
        if (res == 1) {
          this.nameList.examiner.forEach(el => {
            el.gh_id === id ? (el.point = point) : "";
          });
        }
      });
    },
    setPicked(obj) {
      console.log(obj);
      this.picked.obj = obj;
      this.picked.flag = true;
    },
    getMsg(id) {
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: { function: "getNameListMsg", id: id, dep: this.mainDep }
      }).done(res => {
        const jsonData = JSON.parse(res);
        let ary = jsonData.map(el => {
          let name = "",
            link = [];
          this.mainNameList.forEach(item => {
            if (item.id == el.gh_id) name = item.name;
          });
          if (el.msgurl) {
            let linkary = el.msgurl.split("||");
            link = linkary.slice(0, linkary.length - 1);
          }
          return {
            content: el.content,
            name: name,
            date: el.edit_date.split(" ")[0],
            link: link
          };
        });
        this.picked.msg = ary;
      });
    },
    getDutyAndSkillHandler() {
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: {
          function: "getExaminerTypeList",
          dep: this.mainDep,
          typeCode: "dutyandskill"
        }
      }).done(res => {
        let jsonData = JSON.parse(res).map(name => name["type_name"]);
        this.allDuty = jsonData;
      });
    },
    getMsgTypeList() {
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: {
          function: "getExaminerTypeList",
          dep: this.mainDep,
          typeCode: "msg"
        }
      }).done(res => {
        const jsonData = JSON.parse(res).map(name => name["type_name"]);
        this.msgTypeList = jsonData;
      });
    },
    showEdit() {
      const vm = this;
      $("#mainDuty")
        .select2({
          tags: true,
          width: "100%"
        })
        .on("change", function(e) {
          vm.picked.edit.duty = $(this).val();
        });

      $("#mainSkill")
        .select2({
          tags: true,
          width: "100%"
        })
        .on("change", function(e) {
          vm.picked.edit.skill = $(this).val();
        });
      $("#myModal_edit").modal("show");
    },
    setEditData() {
      let ary = [];
      ary.push(this.picked.edit.duty);
      ary.push(this.picked.edit.skill);
      ary.push(this.picked.edit.ontime);
      ary.push(this.picked.edit.offtime);
      ary.push(this.picked.obj.id);
      ary.push(this.picked.obj.name);
      ary.push(this.mainDep);
      $.ajax({
        url: "./php/main.php",
        // url: '/api/main.php',
        type: "post",
        data: { function: "SaveDutyAndSkill", data: JSON.stringify(ary) }
      }).done(res => {
        const data = JSON.parse(res);
        if (data[0] === 1) {
          const {
            mainDuty,
            workskill,
            onWorkTime,
            offWorkTime,
            gh_id
          } = data[1][0];
          this.picked.obj.duty = mainDuty;
          this.picked.obj.skill = workskill;
          this.picked.obj.workTime = `${onWorkTime}~${offWorkTime}`;
        }
        $("#myModal_edit").modal("hide");
      });
    },
    changeAvart(e) {
      const file = e.target.files[0];
      if (!file) return false;
      const vm = this;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("function", "changeAvatar");
      formData.append("id", vm.picked.obj.id);
      formData.append("department", vm.mainDep);
      vm.picked.imgUpload = true;
      let xhr = new XMLHttpRequest();
      xhr.open("POST", "./php/main.php", true);
      xhr.onload = function() {
        if (xhr.status == 200) {
          let resp = JSON.parse(xhr.response);
          vm.picked.imgUpload = false;
        }
      };
      xhr.send(formData);
    },
    saveMsg() {
      const vm = this;
      if (vm.picked.alert.msgTitle === "" || vm.picked.alert.msgTxt === "")
        return false;
      const msgTag = "2";
      const { msgTitle, msgTxt, fileContent: files } = vm.picked.alert;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }

      formData.append("function", "SaveMsgIntoDB");
      formData.append("typecode", msgTag);
      formData.append("title", msgTitle);
      formData.append("content", msgTxt);
      formData.append("id", vm.picked.obj.id);
      formData.append("department", vm.mainDep);
      let curDate = new Date();
      let editdate = `${vm.time.today} ${String(curDate.getHours()).padStart(
        2,
        "0"
      )}:${String(curDate.getMinutes()).padStart(2, "0")}:${String(
        curDate.getSeconds()
      ).padStart(2, "0")}`;
      formData.append("editdate", editdate);

      let xhr = new XMLHttpRequest();
      xhr.open("POST", "./php/main.php", true);
      xhr.onload = function() {
        if (xhr.status == 200) {
          let { res, content, date, link, name } = JSON.parse(xhr.response);
          if (link) {
            link = link.split("||");
            link = link.slice(0, link.length - 1);
          }
          date = date.split(" ")[0];
          let obj = {
            name,
            content,
            date,
            link
          };
          vm.picked.msg.push(obj);
          vm.picked.alert.msgTitle = "";
          vm.picked.alert.msgTxt = "";
          vm.picked.alert.fileContent = {};
          $("#myModal_msg").modal("hide");
        }
      };
      xhr.send(formData);
    },
    uploadMsgFile(e) {
      const fileList = e.target.files;
      this.picked.alert.fileContent = fileList;
    },
    getTimeLineData(name, id) {
      if (this.picked.timeLine.getTimeLineReq !== "") {
        this.picked.timeLine.getTimeLineReq.abort();
      }
      let curDate = new Date(this.time.today);
      let nowTime = curDate.getTime();
      let StartDate = `${curDate.getFullYear()}-${String(
        curDate.getMonth() + 1
      ).padStart(2, "0")}-${String(curDate.getDate()).padStart(2, "0")}`;
      curDate = new Date(nowTime + 1000 * 60 * 60 * 24);
      let EndDate = `${curDate.getFullYear()}-${String(
        curDate.getMonth() + 1
      ).padStart(2, "0")}-${String(curDate.getDate()).padStart(2, "0")}`;
      let dateStr = `${StartDate} 08:00:00@${EndDate} 08:00:00`;
      this.picked.timeLine.getTimeLineReq = $.ajax({
        url: "./php/main.php",
        type: "post",
        data: {
          function: "GetTimeLineData",
          Repsname: name,
          dep: this.mainDep,
          dateStr: dateStr,
          id: id
        }
      }).done(res => {
        let jsonData = JSON.parse(res);
        if (jsonData[0].length == 0 && jsonData[1].length == 0) {
          return (this.picked.timeLine.timeLineData = []);
        }
        let dataAry = [].concat(jsonData[0]);
        jsonData[1].forEach(el => dataAry.push(el.logtxt));
        // jsonData = sortTimeLine(dataAry);
        this.picked.timeLine.timeLineData = dataAry;
      });
    },
    deleteTimeLineData(val) {
      const id = this.picked.obj.id;
      if (confirm("確定刪除嗎？")) {
        $.ajax({
          url: "./php/main.php",
          // url: '/api/main.php',
          type: "post",
          data: { function: "deleteTimeLineLog", logtxt: val, id: id }
        }).done(res => {
          //  this. getTimeLineData(this.picked.obj.name, this.picked.obj.id);
          this.picked.timeLine.timeLineData = this.picked.timeLine.timeLineData.reduce(
            (prev, next) => {
              next !== val ? prev.push(next) : "";
              return prev;
            },
            []
          );
        });
      }
    },
    addNewWork() {
      if (!this.picked.timeLine.content || !this.picked.timeLine.inputTime) {
        return;
      }
      let content = this.picked.timeLine.content;
      let time = this.picked.timeLine.inputTime.split("T");
      time = `${time[0]} ${time[1]}`;
      content = time + ":00.00>>" + content;
      time = time + ":00";
      const id = this.picked.obj.id;
      if (id !== this.User.userId) {
        this.$bus.$emit("message:push", "非本人無法新增", "danger");
        this.picked.timeLine.content = "";
        this.picked.timeLine.inputTime = "";
        return false;
      }
      $.ajax({
        url: "./php/main.php",
        type: "post",
        data: {
          function: "addContentIntoLog",
          content: content,
          id: id,
          time: time
        }
      }).done(res => {
        this.picked.timeLine.content = "";
        this.picked.timeLine.inputTime = "";
        // this. getTimeLineData(this.picked.obj.name, this.picked.obj.id);
        const data = JSON.parse(res);
        this.picked.timeLine.timeLineData.push(data.logtxt);
      });
    },
    setTrackMemberHandler(n) {
      const id = this.picked.obj.id;
      $.ajax({
        url: "./php/main.php",
        type: "post",
        data: {
          function: "setTrackList",
          id: this.User.userId,
          actionId: id,
          trigger: n
        }
      }).done(res => {
        const { tracklist } = JSON.parse(res)[0];
        this.$emit("update:trackList", tracklist);
      });
    }
  },
  watch: {
    // mainData() {
    //   this.setMembers();
    // }
  }
};

function sortTimeLine(ary) {
  ary.sort((a, b) => {
    let Ayear, Amonth, Adate, Ahr, Amin, Asec;
    let Byear, Bmonth, Bdate, Bhr, Bmin, Bsec;

    if (a.indexOf("=>") != -1) {
      [Ayear, Amonth, Adate] = a
        .split("=>")[1]
        .split(" ")[0]
        .split("-");
      [Ahr, Amin, Asec] = a
        .split("=>")[1]
        .split(" ")[1]
        .split(">>")[0]
        .split(":");
      [Byear, Bmonth, Bdate] = b
        .split("=>")[1]
        .split(" ")[0]
        .split("-");
      [Bhr, Bmin, Bsec] = b
        .split("=>")[1]
        .split(" ")[1]
        .split(">>")[0]
        .split(":");
    } else {
      [Ayear, Amonth, Adate] = a.split(" ")[0].split("-");
      [Ahr, Amin, Asec] = a
        .split(" ")[1]
        .split(">>")[0]
        .split(":");
      [Byear, Bmonth, Bdate] = b.split(" ")[0].split("-");
      [Bhr, Bmin, Bsec] = b
        .split(" ")[1]
        .split(">>")[0]
        .split(":");
    }

    if (Ayear - Byear < 0) {
      return -1;
    } else if (Byear - Ayear < 0) {
      return 1;
    }

    if (Amonth - Bmonth < 0) {
      return -1;
    } else if (Bmonth - Amonth < 0) {
      return 1;
    }

    if (Adate - Bdate < 0) {
      return -1;
    } else if (Bdate - Adate < 0) {
      return 1;
    }

    if (Ahr - Bhr < 0) {
      return -1;
    } else if (Bhr - Ahr < 0) {
      return 1;
    }

    if (Amin - Bmin < 0) {
      return -1;
    } else if (Bmin - Amin < 0) {
      return 1;
    }

    if (Asec - Bsec < 0) {
      return -1;
    } else if (Bsec - Asec < 0) {
      return 1;
    }
  });
  return ary;
}
</script>

<style>
@import "../../assets/css/lib/select2/select2.min.css";
.namelistGroup {
  margin: auto 3px !important;
}

.gradeActive {
  color: rgb(255, 193, 7);
}

.btn-addon {
  position: relative;
  padding-left: 40px !important;
}
.btn-warning {
  color: #fff !important;
}

.follow {
  margin-right: 5px;
}

.personInfo .evaluate i {
  cursor: default;
}
</style>